import { Module } from 'vuex'

const MIN_TEST_FRAME_HEIGHT = 200
const MIN_TEST_PANEL_HEIGHT = 90

interface EditorPageState {
  sourceCode: string
  testFrameHeight: number // テストフレーム全体の高さ (試す・提出含む)
  maxTestFrameHeight: number
  testPanelHeight: number // 入力・想定出力・出力パネルの高さ
  isHandlingTestFrame: boolean
  isFreeSpaceMode: boolean
  isErrorShow: boolean
  errorMessage: string | null
  isPastingIOConsole: boolean
}

export const editorPageStateModule = (): Module<EditorPageState, any> => {
  return {
    namespaced: true,
    state: {
      sourceCode: '',
      testFrameHeight: 200,
      maxTestFrameHeight: window.innerHeight / 2,
      testPanelHeight: 90,
      isHandlingTestFrame: false,
      isFreeSpaceMode: false,
      isErrorShow: false,
      errorMessage: null,
      isPastingIOConsole: false
    },
    mutations: {
      setSourceCode(state, { sourceCode }: { sourceCode: string }) {
        state.sourceCode = sourceCode
      },
      setTestFrameHeight(state, { height }: { height: number }) {
        if (height < MIN_TEST_FRAME_HEIGHT) {
          state.testFrameHeight = MIN_TEST_FRAME_HEIGHT
        } else if (height > state.maxTestFrameHeight) {
          state.testFrameHeight = state.maxTestFrameHeight
        } else {
          state.testFrameHeight = height
        }
      },
      setMaxTestFrameHeight(state, { height }: { height: number }) {
        state.maxTestFrameHeight = height
      },
      setTestPanelHeight(state, { height }: { height: number }) {
        if (height < MIN_TEST_PANEL_HEIGHT) {
          state.testPanelHeight = MIN_TEST_PANEL_HEIGHT
        } else if (height > state.testFrameHeight - 110) {
          state.testPanelHeight = state.testFrameHeight - 110
        } else {
          state.testPanelHeight = height
        }
      },
      setIsHandlingTestFrame(state, { flag }: { flag: boolean }) {
        state.isHandlingTestFrame = flag
      },
      setIsFreeSpaceMode(state, { isFreeSpaceMode }: { isFreeSpaceMode: boolean }) {
        state.isFreeSpaceMode = isFreeSpaceMode
      },
      setIsErrorShow(state, { isErrorShow }: { isErrorShow: boolean }) {
        state.isErrorShow = isErrorShow
      },
      setErrorMessage(state, { errorMessage }: { errorMessage: string | null }) {
        state.errorMessage = errorMessage
      },
      setIsPastingIOConsole(state, { isPastingIOConsole }: { isPastingIOConsole: boolean }) {
        state.isPastingIOConsole = isPastingIOConsole
      }
    },
    actions: {
      updateMaxTestFrameHeight({ state, commit, dispatch }, { height }: { height: number }) {
        commit('setMaxTestFrameHeight', { height })

        // testFrameHeightが最大値を超えていたら修正
        if (state.testFrameHeight > height) {
          dispatch('updateTestFrameHeight', { height })
        }
      },
      updateTestFrameHeight({ state, commit }, { height }: { height: number }) {
        const trimHeight = Math.floor(height)
        commit('setTestFrameHeight', { height: trimHeight })
        commit('setTestPanelHeight', { height: trimHeight - 110 })
      }
    },
    getters: {
      sourceCode: state => state.sourceCode,
      testFrameHeight: state => state.testFrameHeight,
      maxTestFrameHeight: state => state.maxTestFrameHeight,
      testPanelHeight: state => state.testPanelHeight,
      isHandlingTestFrame: state => state.isHandlingTestFrame,
      isFreeSpaceMode: state => state.isFreeSpaceMode,
      isErrorShow: state => state.isErrorShow,
      errorMessage: state => state.errorMessage,
      isPastingIOConsole: state => state.isPastingIOConsole
    }
  }
}
